var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "club-points-history" },
    [
      _c(
        "div",
        { staticClass: "club-points-history__form" },
        [
          _c("ui-input", {
            attrs: {
              mask: "interval",
              label: "Период",
              placeholder: "дд.мм.гггг - дд.мм.гггг",
              clearable: ""
            },
            on: { "mask-completed": _vm.submit },
            model: {
              value: _vm.date,
              callback: function($$v) {
                _vm.date = $$v
              },
              expression: "date"
            }
          })
        ],
        1
      ),
      !_vm.history.length
        ? _c("page-info", {
            attrs: {
              title: "Операций с бонусами в выбранный период не производилось"
            }
          })
        : _c("vue-client-only", [
            _c(
              "div",
              [
                _vm.adaptive.isMobile
                  ? _c("club-points-history-table", {
                      attrs: { "history-records": _vm.history }
                    })
                  : _c("club-points-history-table-desktop", {
                      attrs: { "history-records": _vm.history }
                    })
              ],
              1
            )
          ]),
      _c("order-popup", { attrs: { "redirect-to-orders": "" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }